(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdt-bereits-geschaeftskunde"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setupPhone(root) {
      var input = root.querySelector('input[type="tel"][name="contact[phone]"]');
      if (!input || input.__iti) return;
      function start() {
        if (typeof window.intlTelInput !== 'function') {
          return setTimeout(start, 80);
        }
        input.__iti = window.intlTelInput(input, {
          initialCountry: 'auto',
          geoIpLookup: function (success) {
            fetch('https://ipapi.co/json')
              .then(function (r) { return r.json(); })
              .then(function (d) { success((d && d.country_code) || 'fr'); })
              .catch(function () { success('fr'); });
          },
          separateDialCode: true,
          autoPlaceholder: 'off',
          utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@23.0.12/build/js/utils.js'
        });
        input.form && input.form.addEventListener('submit', function () {
          if (input.__iti) input.value = input.__iti.getNumber();
        });
      }
      start();
    }

    function init(root) {
      if (!root || root.__pdtBgkInit) return;
      root.__pdtBgkInit = true;

      var steps = root.querySelectorAll('[data-step]');
      if (!steps.length) return;
      var bar = root.querySelector('[data-progress-bar]');
      var btnPrev = root.querySelector('[data-prev]');
      var btnNext = root.querySelector('[data-next]');
      var btnSubmit = root.querySelector('[data-submit]');
      var total = steps.length;
      var current = 1;

      function isValid(stepEl) {
        var fields = stepEl.querySelectorAll('input, select, textarea');
        for (var i = 0; i < fields.length; i++) {
          if (!fields[i].checkValidity()) {
            fields[i].reportValidity();
            return false;
          }
        }
        return true;
      }

      function render() {
        steps.forEach(function (s) {
          s.classList.toggle('is-active', Number(s.dataset.step) === current);
        });
        bar.style.width = (current / total * 100) + '%';
        btnPrev.hidden = current === 1;
        btnNext.hidden = current === total;
        btnSubmit.hidden = current !== total;
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      btnNext.addEventListener('click', function () {
        var stepEl = root.querySelector('[data-step="' + current + '"]');
        if (!isValid(stepEl)) return;
        if (current < total) { current++; render(); }
      });
      btnPrev.addEventListener('click', function () {
        if (current > 1) { current--; render(); }
      });

      setupPhone(root);
      render();
    }

    document.querySelectorAll('[data-pdt-bgk]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector ? e.target.querySelector('[data-pdt-bgk]') : null;
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdt-commitments"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(carousel) {
      if (carousel.dataset.pdtCarouselReady === '1') return;
      carousel.dataset.pdtCarouselReady = '1';

      var track = carousel.querySelector('[data-pdt-carousel-track]');
      var slides = track ? track.children : [];
      var total = slides.length;
      if (!track || total < 2) return;

      var prevBtn = carousel.querySelector('[data-pdt-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-pdt-carousel-next]');
      var dots = carousel.querySelectorAll('[data-pdt-carousel-dot]');
      var current = 0;

      function goTo(i) {
        current = ((i % total) + total) % total;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
        for (var d = 0; d < dots.length; d++) {
          dots[d].setAttribute('aria-current', d === current ? 'true' : 'false');
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
      for (var k = 0; k < dots.length; k++) {
        (function (idx) {
          dots[idx].addEventListener('click', function () { goTo(idx); });
        })(k);
      }

      carousel.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { goTo(current - 1); }
        else if (e.key === 'ArrowRight') { goTo(current + 1); }
      });

      var startX = null;
      track.addEventListener('touchstart', function (e) {
        if (e.touches && e.touches.length === 1) startX = e.touches[0].clientX;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var endX = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : startX;
        var dx = endX - startX;
        if (Math.abs(dx) > 40) goTo(current + (dx < 0 ? 1 : -1));
        startX = null;
      });

      goTo(0);
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-pdt-carousel]').forEach(initCarousel);
    }

    initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdt-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      (root || document).querySelectorAll('[data-pdt-faq-toggle]').forEach(function (btn) {
        if (btn.dataset.pdtFaqReady === '1') return;
        btn.dataset.pdtFaqReady = '1';
        btn.addEventListener('click', function () {
          var item = btn.closest('[data-pdt-faq-item]');
          if (!item) return;
          var isOpen = item.getAttribute('data-open') === 'true';
          item.setAttribute('data-open', isOpen ? 'false' : 'true');
          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
      });
    }
    initFaq();
    document.addEventListener('shopify:section:load', function (e) { initFaq(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
